<div class="reviews">
  <div>
    <div col-12 class="reviews_mainTitle" [innerHTML]="reviewsTitle">
    </div>
    <div col-12 class="reviews_wrapper">
      <div class="reviews_review" *ngFor="let review of reviews">
        <div *ngIf="review.video">
          <simple-video-player [videoID]="review.video.id"></simple-video-player>
        </div>
        <div>
          <div class="reviews_items">
            <div class="reviews_stars" *ngIf="review.stars">
              <img src="{{ star }}" *ngFor="let stars of Arr(review.stars).fill(0)" />
            </div>
            <div class="reviews_title" [innerHTML]="review.title" *ngIf="review.title"></div>
            <div class="reviews_content" [innerHTML]="review.content" *ngIf="review.content"></div>
            <div class="reviews_author" [innerHTML]="review.author" *ngIf="review.author"></div>
            <div class="reviews_date" [innerHTML]="review.date" *ngIf="review.date"></div>
            <div class="reviews_addOn" [innerHTML]="perReviewAddOn" *ngIf="perReviewAddOn"></div>
            <div class="reviews_varyingResults" [innerHTML]="varyingText"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>